import { Heading } from '@carbon/react';
import React from 'react';
import * as styles from '../../scans/[id]/page.module.css';
import PageHeader from '../header';
interface ErrorContent {
  heading?: React.ReactNode;
  status?: number;
  message?: string;
  linkText?: string;
  link?: string;
}
type GenericErrorProps = {
  content: ErrorContent;
};

const GenericError: React.FC<GenericErrorProps> = ({ content }) => {
  const { heading, status, message, linkText, link } = content;
  return (
    <div data-testid="generic-error" className={styles.errorComponent}>
      <PageHeader showAvatar={false} />
      <Heading className={styles.headingColor}>
        {status} {heading}
      </Heading>
      <p className={styles.message}>{message}</p>
      {link && (
        <a href={link} className={styles.errorLink}>
          {linkText}
        </a>
      )}
    </div>
  );
};
export default GenericError;
